/*
 * @Author: 鸦雀銮翎
 * @Date: 2023-01-11 14:33:43
 * @LastEditTime: 2023-05-10 14:32:01
 * @Description:
 * @FilePath: \website\src\router\index.js
 * 可以输入预定的版权声明、个性签名、空行等
 */
import Vue from 'vue';
import Router from 'vue-router';
import home from '../pages/home/index';
import aboutus from '../pages/aboutus/index';
import quotation from '../pages/quotation/index';
import smartService from '../pages/smartService/index';
import news from '../pages/news/index';
import content from '../pages/news/content';
import cooperator from '../pages/cooperator/index';

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: aboutus,
    },
    {
      path: '/quotation',
      name: 'quotation',
      component: quotation,
    },
    {
      path: '/smartService',
      name: 'smartService',
      component: smartService,
    },
    {
      path: '/news',
      name: 'news',
      component: news,
    },
    {
      path: '/content',
      name: 'content',
      component: content,
    },
    {
      path: '/cooperator',
      name: 'cooperator',
      component: cooperator,
    },

  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js